/*LIBRARY MODULE*/
import { Component } from "react";
import { connect } from "react-redux";

/*PERSONAL COMPONENT*/

/*REDUX FUNCTION*/
import {
  get_price_2025,
  calculate_price,
} from "../../App/actions/paymentActions";

/*PICTURE ASSET*/

/*GENERAL*/
// import PricingCard from "./PricingCard";

import dict from "../../Data/dict.json";
import { set_value_user } from "../../App/actions/authActions";
// import { Modal } from "../reuseable";
import { CheckCircle } from "@material-ui/icons";
import getCssVariable from "../../App/validation/getCssVariable";
import { Button, Switch } from "@mui/material";
import { convert_to_currency_with_unit } from "../../App/validation/convert_to_currency_with_unit";

/*NON IMPORT*/

// const all_licenses = [
//   {
//     license_key: "license_basic",
//     label: "Basic",
//   },
//   {
//     license_key: "license_sini_ai",
//     label: "SINI AI",
//   },
//   {
//     license_key: "license_sini_data",
//     label: "SINI DATA",
//   },
// ]

// const all_included_licenses = all_licenses.map(item => item.license_key);

class PaymentTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      personal: {
        price: 0,
        no_discount: 0,
        month: 1,
        licenses: [],
      },
      prices: {
        license_basic: {
          showed_price_without_discount: 0,
          showed_price: 0
        },
        license_sini_ai: {
          showed_price_without_discount: 0,
          showed_price: 0
        },
        license_sini_data: {
          showed_price_without_discount: 0,
          showed_price: 0
        },
      },
    };
  }

  componentDidMount = async () => {
    await this.props.get_price_2025();
    await this.get_license_price();

    const logedin = localStorage.getItem("token_mapid");
    if (logedin) {
      const { set_package_selected } = this.props;
      const params = new URLSearchParams(window.location.search);
      const payment_type = params.get("payment_type"); // string, ex: "personal", "team", "enterprise"
      const month = +params.get("month") || 1; // number
      const license = params.get("license");

      if (payment_type === "personal") {
        set_package_selected(payment_type);
        this.handleLicenseChecklist(license, month)
      }
    }

  }

  componentDidUpdate = async (prevProps, prevState) => {
    const is_month_personal_diff =
      prevState?.personal?.month !== this.state?.personal?.month;
    const is_license_personal_diff =
      JSON.stringify(prevState?.personal?.licenses) !==
      JSON.stringify(this.state?.personal?.licenses);

    if (
      is_month_personal_diff ||
      is_license_personal_diff
    ) {
      this.calculate_price();
    }
  };

  toggleSwitchMonth = () => {
    const month = this.state.personal.month;
    this.setState({
      personal: {
        ...this.state?.personal,
        month: month === 1 ? 12 : 1,
      },
    }, async () => {
      await this.get_license_price();
    })
  }

  toggleBuyNow = () => {
    const { set_page, package_selected } = this.props;
    if (set_page) {
      set_page({
        package_object: {
          ...this.state?.[package_selected],
          package_type: package_selected,
        },
        new_page: "payment_method",
      });
    }
  };

  get_license_price = async () => {
    const { month } = this.state.personal;
    const { auth, license_features } = this.props;
    const currency =
      (auth?.user?.country || "Indonesia") === "Indonesia" ? "IDR" : "USD";

    const with_month = license_features.map(item => ({
      license_key: item.key,
      month: month,
    }))

    const body = {
      package_type: "personal",
      currency,
      license_includes: with_month
    }

    const res_calculation = await this.props.calculate_price(body);

    let prices = { ...this.state.prices }
    for (const item of res_calculation?.items) {
      prices[item.key]["showed_price_without_discount"] = item?.showed_price_without_discount === item?.showed_price ? 0 : item?.showed_price_without_discount;
      prices[item.key]["showed_price"] = item?.showed_price;
    };

    this.setState({ prices })
  }

  calculate_price = async (package_name) => {
    const { package_selected, auth } = this.props;
    let new_package_name = package_name || package_selected;
    const selected_package = this.state?.[new_package_name];
    const currency =
      (auth?.user?.country || "Indonesia") === "Indonesia" ? "IDR" : "USD";

    const res_calculation = await this.props.calculate_price({
      package_type: new_package_name,
      currency,
      license_includes: selected_package?.licenses?.map((license) => ({
        license_key: license,
        month: selected_package?.["month"],
      })),
      collaborators: selected_package?.collaborators,
    });

    this.setState({
      [new_package_name]: {
        ...this.state?.[new_package_name],
        price: res_calculation?.showed_price,
        no_discount: res_calculation?.showed_price_without_discount,
      },
    })
  }

  handleLicenseChecklist = (license_key, month) => {
    const { license_features, license_reducer } = this.props;
    const { licenses } = this.state.personal;
    const all_license_keys = license_features.filter(item => !license_reducer[item.key]?.is_has_license)?.map(item => item.key);

    let selected_licenses = []
    all_license_keys.forEach(item => {
      if (!license_reducer[item]?.is_has_license && item === license_key) {
        if (!licenses.includes(license_key)) {
          const idx = all_license_keys.findIndex(key => key === license_key);
          selected_licenses.push(...all_license_keys.slice(0, idx + 1))
        }
        else {
          const idx = all_license_keys.findIndex(key => key === license_key);
          selected_licenses.push(...all_license_keys.slice(0, idx))
        }
      }
    })

    let body = {
      personal: {
        ...this.state.personal,
        licenses: selected_licenses,
      }
    }

    if (month > 0) {
      body.month = month
    }

    this.setState(body);
  };

  handle_duration = (package_type) => {
    const { month } = this.state?.[package_type] || {};
    const value = month === 12 ? 1 : 12;

    this.setState({
      [package_type]: {
        ...this.state?.[package_type],
        month: value,
      },
    });
  };

  handle_collaborators = (operator) => {
    const { collaborators } = this.state?.["team"] || {};

    let value = collaborators;
    if (operator === "+" && value < 10) {
      value = collaborators + 1;
    } else if (operator === "-" && value > 2) {
      value = collaborators - 1;
    }

    this.setState({
      team: {
        ...this.state?.["team"],
        collaborators: value,
      },
    });
  };

  render() {
    //local storage
    const language = localStorage?.language ? localStorage?.language : "ina";

    //local state
    const { personal, prices } = this.state;
    // console.log(personal?.licenses)

    //global props
    const { auth, license_features, license_reducer } = this.props;
    const all_license_keys = license_features.map(item => item.key);

    let your_license = {}
    all_license_keys.forEach(item => {
      your_license[item] = license_reducer[item]?.is_has_license || false
    })

    const currency = (auth?.user?.country || "Indonesia") === "Indonesia" ? "IDR" : "USD";

    const disabled_color = {
      border: `3px solid ${getCssVariable("--pasive")}`,
      backgroundColor: getCssVariable("--pasive"),
      color: getCssVariable("--text-active"),
      height: "240px"
    };
    const active_color = {
      border: `3px solid ${getCssVariable("--active")}`,
      color: getCssVariable("--text-accent"),
      cursor: "pointer",
      height: "240px"
    }
    const base_color = {
      border: `3px solid ${getCssVariable("--pasive")}`,
      backgroundColor: getCssVariable("--base"),
      color: getCssVariable("--accent"),
      cursor: "pointer",
      height: "240px"
    }

    const prices_render = license_features.map((license, idx) => {
      let card_style = base_color
      if (your_license[license.key]) {
        card_style = disabled_color
      } else if (personal?.licenses.includes(license.key)) {
        card_style = active_color
      }

      return <div
        key={idx}
        style={card_style}
        className="w_300 rounded_10 padding_10 noselect relative flex flex_col gap_5"
        onClick={() => this.handleLicenseChecklist(license.key)}
      >
        <div>
          <div className="flex w_full" style={{ justifyContent: "space-between" }}>
            <h2>{license.name?.[language]}</h2>
            {your_license[license.key] && <label className="bg_black rounded_5 padding_y_2 padding_x_10 center_perfect">{dict["You already have"][language]}</label>}
          </div>
          <hr />
        </div>

        <div>
          {prices?.[license.key]?.showed_price_without_discount > 0 && !your_license[license.key] && <div>
            <label style={{ fontSize: "14px", textDecoration: "line-through", color: "#D10000" }}>
              {convert_to_currency_with_unit({
                currency,
                value: prices?.[license.key]?.showed_price_without_discount
              })}
            </label>
          </div>}

          {!your_license[license.key] && <div className="flex align_end">
            <h2 className="bold">{convert_to_currency_with_unit({ currency, value: prices?.[license.key]?.showed_price })}</h2>
            <h4>/{dict["months"][language]}</h4>
          </div>}
        </div>


        <div className="flex flex_col gap_5">
          {license?.["subfeatures"] && license?.["subfeatures"].map(
            ({ subfeature_name, ...name }, sub_idx) => (
              <div
                key={sub_idx}
                className="flex align_center gap_5">
                <CheckCircle
                  fontSize="small"
                />
                {name[language]}
              </div>
            )
          )}
        </div>
      </div>
    })

    return (
      <main>
        <section className="flex justify_center">
          {/* <label className="underline">{duration?.header}</label> */}
          <div className="flex align_center bg_lightGrey rounded_50 marginBottom_10 padding_x_20 padding_y_5" style={{ border: "2px solid" }}>
            <label>1</label>
            <Switch
              sx={{
                "& .MuiSwitch-switchBase.Mui-checked": {
                  color: "#000",
                },
                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                  backgroundColor: "#000",
                },
              }}
              checked={personal?.month === 12 ? true : false}
              onChange={() => {
                this.toggleSwitchMonth()
                // duration?.onChange(package_type);
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
            <label>12</label>
            <label className="marginLeft_10">
              month{personal?.month === 12 ? "s" : ""}
            </label>
          </div>
        </section>
        <div
          style={{
            width: "100%",
            overflowX: "auto",
          }}
        >
          <div className="adaptive_justify">
            <div style={{
              display: "flex",
              gap: "20px",
              minWidth: "max-content",
            }}>
              {prices_render}
            </div>
          </div>
        </div>
        <div className="center_perfect h_100">
          {
            <Button
              onClick={() => { if (personal?.licenses?.length > 0) this.toggleBuyNow() }}
              variant="contained"
              color={personal?.licenses?.length > 0 ? "primary" : "tertiary"}
              style={{
                width: "200px",
                cursor: personal?.licenses?.length > 0 ? "pointer" : "default"
              }}
            >
              {dict["Buy"][language]}
            </Button>
          }
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    payment: state.payment,
    license_reducer: state.license_reducer,
    license_features: state.payment.license_features_2025,
  }
};

export default connect(mapStateToProps, {
  get_price_2025,
  calculate_price,
  set_value_user,
})(PaymentTable);
